import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get_users_by_product } from "@src/redux/action/access_control/UsersAction";
import AvatarPng from "@components/avatar/avatr.png";

SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: false,
};

const Team = ({ t }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      get_users_by_product({
        page: 1,
        per_page: 12,
      })
    );
  }, []);
  const user_by_product = useSelector(
    (state) => state.UserReducers.users_by_product_id
  );
  return (
    <section className="section team-part">
      <div className="container__video">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-heading">
              <h2>{t("Introduce Our Team")}</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="team-slider slider-arrow">
              <div className="">
                <Swiper {...params}>
                  {user_by_product?.data?.map((user) => (
                    <SwiperSlide
                      key={user.id}
                      style={{
                        display: "flex",
                        gap:"12px",
                        textAlign:"center",
                        flexDirection:"column",
                        alignItems:"center"
                      }}
                    >
                      <img
                        width="280px"
                        height="180px"
                        style={{ objectFit: "contain" }}
                        src={user.avatar ? user.avatar : AvatarPng}
                        alt={user?.user_name}
                        className="img-fluid"
                      />
                      <b>
                        {user.first_name} {user.last_name}
                      </b>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="team-btn">
              <Link className="btn btn-outline" to="/team">
                <i className="fa fa-eye me-1"></i>
                <span>{t("show more")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
